import { News } from "../models/news"
import { AnomalyNewsDataObject } from "../models/data/news"

export const newsListFromDataObject = (data: AnomalyNewsDataObject): News[] | null => {
    const newsList: News[] = []
    data.anomaly_news.forEach(news => {
        if (news.news_data) {
            newsList.push({
                time: news.time,
                news: news.news_data
            })
        }
    })
    return newsList
}